import React from 'react';
import { Modal, Box, Typography, IconButton, Button } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface SoldOutConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SoldOutConfirmationModal: React.FC<SoldOutConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="sold-out-confirmation-modal"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 1,
          borderRadius: 2,
          width: isSmallScreen ? '90vw' : 500,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            py: 0.5,
          }}
        >
          <Typography variant="h5" component="h5" align="left" sx={{ px: 2 }}>
            Are you sure?
          </Typography>
          <IconButton
            onClick={onClose}
            aria-label="Close"
            sx={{ position: 'absolute', top: 0, right: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography variant="body1" sx={{ px: 2, py: 1 }}>
          Once you remove this item from your order, you won&apos;t be able to
          add it back during this delivery week due to limited quantity.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            px: 2,
            py: 1,
          }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ textTransform: 'none' }}
          >
            Nevermind
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
            sx={{ textTransform: 'none' }}
          >
            Yes, Remove
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SoldOutConfirmationModal;
